import useCurrentUser from '~/hooks/useCurrentUser'
import { DEFAULT_AVATAR_URL } from '~/shared/constants/assets.const'
import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'

import { AvatarPng } from '../types/dashboard.types'

import { toAvatarPng } from './util'

/**
 * The signed-in user's avatar, or `userId`'s when that user is in their family.
 *
 * ⚠ `userId` is looked up in the signed-in user's family only. Any other id returns the default
 * avatar with no error. For a subject outside the family, call `toAvatarPng` with their `avatarUrl`.
 */
export default function useAvatarImageUrl(userId?: number): AvatarPng {
  const user = useCurrentUser()
  const familyProfiles = useCurrentFamily().familyUserData

  const avatarUrl = userId ? familyProfiles?.find((profile) => profile.userId === userId)?.avatarUrl : user?.avatarUrl

  if (!user) {
    return { url: DEFAULT_AVATAR_URL, isUnder13: false, isExists: false, isLoading: true }
  }

  return toAvatarPng(avatarUrl)
}
